import styled from "styled-components";
import {trophyImages} from "../../../content-options/trophy";
import {FC} from "react";

interface Props {
    trophy: string;
    fadedtrophy: string;
    quantity: number;
    imgBottom?: string;
    imgLeft?: string;
    imgRight?: string;
    imgScale?: string;
}

const TwVgcDor: FC<Props> = ({ trophy, quantity, fadedtrophy, imgBottom, imgLeft, imgRight, imgScale }) => {

    const image = quantity ? trophyImages[trophy as keyof typeof trophyImages] : trophyImages[fadedtrophy as keyof typeof trophyImages]

  return (
    <>
      <Container>
          <Img src={image} imgBottom={imgBottom} imgLeft={imgLeft} imgRight={imgRight} imgScale={imgScale} />
      </Container>
    </>
  );
};

export default TwVgcDor;

const Container = styled.div`
  height: 100%;
  aspect-ratio: 1/1;
  overflow: none;
  display: flex;
  position: relative;
  

  @media (min-width: 991px) {
    justify-content: center;
    align-items: center;
  }
`;

interface ImgProps {
  imgBottom?: string;
  imgLeft?: string;
  imgRight?: string;
  imgScale?: string;
}

const Img = styled.img<ImgProps>`
  /* width: 100%; */
  /* aspect-ratio: 1/1; */
  width: 190px;
  padding: 2rem;
  position: absolute;
  bottom: ${props => props.imgBottom || 'auto'};
  left: ${props => props.imgLeft || 'auto'};
  right: ${props => props.imgRight || 'auto'};
  transform: ${props => props.imgScale ? `scale(${props.imgScale})` : 'scale(1)'};

  @media  (max-width: 1199px) {
    width: 200px;
    justify-content: center;
    align-items: center;
  }
  @media (max-width: 991px) {
    width: 190px;
  }
  @media (max-width: 768px) {
    width: 190px;
  }
  @media (max-width: 576px) {
    width: 175px;
  }
  @media (max-width: 480px) {
    width: 150px;
  }
  @media (max-width: 350px) {
    width: 140px;
  }
  /* width: 200px; */
`;
const Quantity = styled.div`
  position: absolute;
  height: 33%;
  width: 33%;
  border: solid black 3px;
  right: -8%;
  bottom: 3%;
  border-radius: 50%;
  background-color: white;
  color: black;
  display: flex;
  justify-content: center;
  align-items: center;
  font-weight: 700;
  @media (min-width: 991px) {
    font-size: larger;
  }
`;
